const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/modules/auth/pages/Entry.vue'),
    meta: {
      guest: true,
      title: 'eRank — Login to Your Account',
      metaTags: [
        {
          name: 'description',
          content: 'Sign in to your eRank account to access your tools and insights.',
        },
        {
          page_slug: 'login',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'login.entry',
        component: () => import('@/modules/auth/pages/login/Index.vue'),
      },
      {
        path: 'confirm',
        name: 'login.confirm',
        component: () => import('@/modules/auth/pages/registration/ConfirmEmail.vue'),
      },
      {
        path: 'activate',
        name: 'login.activate',
        component: () => import('@/modules/auth/pages/login/Activate.vue'),
      },
      {
        path: 'magic',
        name: 'login.magic',
        component: () => import('@/modules/auth/pages/login/MagicLogin.vue'),
      },
      {
        path: 'banned',
        name: 'login.banned',
        component: () => import('@/modules/auth/pages/login/Banned.vue'),
      },
    ],
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/modules/auth/pages/Entry.vue'),
    meta: {
      title: 'eRank — Reset Password',
      metaTags: [
        {
          name: 'description',
          content: 'Reset your eRank password to quickly regain access to your account and continue growing your online shop.',
        },
        {
          page_slug: 'reset-password',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'reset.entry',
        component: () => import('@/modules/auth/pages/reset/Index.vue'),
      },
      {
        path: 'confirm',
        name: 'reset.new-password',
        component: () => import('@/modules/auth/pages/reset/NewPasswordForm.vue'),
      },
    ],
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/modules/auth/pages/Entry.vue'),
    meta: {
      guest: true,
      title: 'eRank — Create Your Account',
      metaTags: [
        {
          name: 'description',
          content: 'Create your free eRank account. Discover powerful tools to track competitors, find keywords, and grow your online shop.',
        },
        {
          page_slug: 'registration',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'registration.entry',
        component: () => import('@/modules/auth/pages/registration/Index.vue'),
      },
      {
        path: 'confirm',
        name: 'registration.confirm',
        component: () => import('@/modules/auth/pages/registration/ConfirmEmail.vue'),
      },
    ],
  },
  {
    path: '/expired',
    name: 'expired',
    component: () => import('@/modules/auth/pages/Entry.vue'),
    meta: {
      guest: true,
    },
    children: [
      {
        path: '',
        name: 'expired.entry',
        component: () => import('@/modules/auth/pages/Expired.vue'),
      },
    ],
  },
];

export const ResetPasswordRoutes = routes.filter(route => route.name === 'reset-password');

export default routes;
